/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'navigation.home',
        subtitle: '',
        icon: 'heroicons_outline:home',
        type: 'group',
        link: '/home',
        children: [
            {
                id: 'home',
                title: 'navigation.home',
                type: 'basic',
                icon: 'heroicons_outline:home',
                link: '/home',
            },
        ],
    },
    {
        id: 'league',
        title: 'navigation.league.title',
        subtitle: 'navigation.league.subtitle',
        icon: 'heroicons_outline:trophy',
        type: 'group',
        link: '/league',
        children: [
            {
                id: 'league.summary',
                title: 'navigation.league.summary',
                type: 'basic',
                icon: 'heroicons_outline:squares-2x2',
                link: '/league/summary',
            },
            {
                id: 'league.team',
                title: 'navigation.league.team',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/league/team',
            },
            {
                id: 'league.schedule',
                title: 'navigation.league.schedule',
                type: 'basic',
                icon: 'heroicons_outline:calendar-days',
                link: '/league/schedule',
            },
            {
                id: 'league.standings',
                title: 'navigation.league.standings',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar',
                link: '/league/standings',
            },
            {
                id: 'league.management',
                title: 'navigation.league.management',
                type: 'basic',
                icon: 'heroicons_outline:wrench-screwdriver',
                link: '/league/management',
                // Filtered by role (captain/admin)
            },
        ],
    },
    {
        id: 'catalanas',
        title: 'navigation.catalanas.title',
        subtitle: 'navigation.catalanas.subtitle',
        icon: 'heroicons_outline:flag',
        type: 'group',
        link: '/catalanas',
        children: [
            {
                id: 'catalanas.overview',
                title: 'navigation.catalanas.overview',
                type: 'basic',
                icon: 'heroicons_outline:calendar-days',
                link: '/catalanas/overview',
            },
            {
                id: 'catalanas.history',
                title: 'navigation.catalanas.history',
                type: 'basic',
                icon: 'heroicons_outline:archive-box',
                link: '/catalanas/history',
            },
            {
                id: 'catalanas.management',
                title: 'navigation.catalanas.management',
                type: 'basic',
                icon: 'heroicons_outline:cog-6-tooth',
                link: '/catalanas/management',
                // Filtered by role (captain/admin)
            },
        ],
    },
    {
        id: 'stats',
        title: 'navigation.stats.title',
        subtitle: 'navigation.stats.subtitle',
        icon: 'heroicons_outline:chart-bar-square',
        type: 'group',
        link: '/stats',
        children: [
            {
                id: 'stats',
                title: 'navigation.stats.title',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar-square',
                link: '/stats',
            },
        ],
    },
];
